module.exports = __webpack_public_path__ + "img/logo.a06bfef7.png";